import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { useTranslation } from "react-i18next";

interface TotalRevenueInputProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}

const TotalRevenueInput = ({ value, onChange, disabled = false }: TotalRevenueInputProps) => {
    const [t] = useTranslation();

    return (
        <div className="revenue-input-container" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <label htmlFor="total-revenue" style={{ margin: 0 }}>
                {t("Subscription.TotalChannelRevenue")}:
            </label>
            {disabled ? (
                <span style={{ fontSize: "13px", padding: "8px 14px" }}>{value || "0.00"} €</span>
            ) : (
                <>
                    <StyledTextField
                        id="total-revenue"
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        size="small"
                        type="number"
                        placeholder="0.00"
                        sx={{
                            width: "150px",
                            "& .MuiOutlinedInput-input": {
                                backgroundColor: "#F5F5F5",
                            },
                        }}
                    />
                    <span style={{ marginLeft: "1px", fontSize: "13px" }}>€</span>
                </>
            )}
        </div>
    );
};

export default TotalRevenueInput;
